import { Link } from "react-router-dom";


export const handleDeviceMenu = (event, index, device, deviceType, {
    id,
    bgColor,
    textColor,
    fontSize,
    text,
    alignVertically,
    alignHorizontally,
    setAddedText,
    setBgColor,
    setTextBgColor,
    setTextColor,
    setWidgetTextColor,
    setFontSize,
    setTextFontSize,
    setTextAlignVertically,
    setTextAlignHorizontally,
    setDeviceMenuPosition,
    setClickedDeviceIndex,
    setIsDeviceMenu,
    setSelectedDeviceId,
    setSelectedDevice,
    setCurrentDevice,
    tempImages,
    tempTabIndexDisplay,
    activeTabIndex,
    setTempImages,
    setUpdatedImages,
    updatedTabIndexDisplay,
    setUpdatedTabIndexDisplay,
    multipleDisplay,
    setMultipleDisplay,
    tempTabIndexText,
    updatedTabIndexText,
    setUpdatedTabIndexText,
    multipleText,
    setMultipleText,
    tempTabIndexMotor,
    updatedTabIndexMotor,
    setUpdatedTabIndexMotor,
    multipleMotor,
    setMultipleMotor,
    tempTabIndexPieChart,
    updatedTabIndexPieChart,
    setUpdatedTabIndexPieChart,
    multiplePieChart,
    setMultiplePieChart,
    tempTabIndexLineChart,
    setUpdatedTabIndexLineChart,
    updatedTabIndexLineChart,
    multipleLineCharts,
    setMultipleLineCharts,
    tempTabIndexBarChart,
    setUpdatedTabIndexBarChart,
    updatedTabIndexBarChart,
    multipleBarChart,
    setMultipleBarChart,
    tempTabIndexHistogram,
    setUpdatedTabIndexHistogram,
    updatedTabIndexHistogram,
    multipleHistogram,
    setMultipleHistogram,
    tempTabIndexGauge,
    setUpdatedTabIndexGauge,
    updatedTabIndexGauge,
    multipleGauge,
    setMultipleGauge,
    tempTabIndexProgress,
    setUpdatedTabIndexProgress,
    updatedTabIndexProgress,
    multipleProgress,
    setMultipleProgress,
    tempTabIndexGrid,
    multipleGrid,
    setUpdatedTabIndexGrid,
    updatedTabIndexGrid,
    setMultipleGrid,
    tempTabIndexTable,
    setUpdatedTabIndexTable,
    updatedTabIndexTable,
    multipleTable,
    setMultipleTable,
    tempTabIndexCircularProgress,
    updatedTabIndexCircularProgress,
    setUpdatedTabIndexCircularProgress,
    multipleCircularProgress,
    setMultipleCircularProgress,
    setUpdatedMultipleCircularProgress,
    updatedMultipleCircularProgress,
    tempTabIndexDoughnut,
    updatedTabIndexDoughnut,
    setUpdatedTabIndexDoughnut,
    updatedMultipleDoughnut,
    setUpdatedMultipleDoughnut,
    tempTabIndexSquare,
    updatedTabIndexSquare,
    setUpdatedTabIndexSquare,
    updatedMultipleSquare,
    setUpdatedMultipleSquare,
    setUpdatedMultipleCircle,
    updatedMultipleCircle,
    setUpdatedTabIndexCircle,
    updatedTabIndexCircle,
    tempTabIndexCircle,
    updatedMultipleTable,
    setUpdatedMultipleTable,
    setUpdatedMultipleGrid,
    updatedMultipleGrid,
    setUpdatedMultipleProgress,
    updatedMultipleProgress,
    updatedMultipleGauge,
    setUpdatedMultipleGauge,
    setUpdatedMultipleHistogram,
    updatedMultipleHistogram,
    setUpdatedMultipleBarChart,
    updatedMultipleBarChart,
    setUpdatedMultiplePieChart,
    updatedMultipleDisplay,
    setUpdatedMultipleDisplay,
    updatedMultipleText,
    setUpdatedMultipleText,
    updatedMultipleMotor,
    setUpdatedMultipleMotor,
    updatedMultipleLineChart,
    setUpdatedMultipleLineChart,
    updatedMultiplePieChart,
    setUpdatedMultipleRadio,
    updatedMultipleRadio,
    setUpdatedTabIndexRadio,
    updatedTabIndexRadio,
    tempTabIndexRadio,
    setUpdatedMultipleSlider,
    updatedMultipleSlider,
    setUpdatedTabIndexSlider,
    updatedTabIndexSlider,
    tempTabIndexSlider,
    setUpdatedMultipleLamp,
    updatedMultipleLamp,
    setUpdatedTabIndexLamp,
    updatedTabIndexLamp,
    tempTabIndexLamp,
    setUpdatedMultiplePush,
    updatedMultiplePush,
    setUpdatedTabIndexPush,
    updatedTabIndexPush,
    tempTabIndexPush,
    setUpdatedMultipleLink,
    updatedMultipleLink,
    setUpdatedTabIndexLink,
    updatedTabIndexLink,
    tempTabIndexLink,
    tempTabIndexClock,
    setUpdatedTabIndexClock,
    updatedTabIndexClock,
    setUpdatedMultipleClock,
    updatedMultipleClock,
    tempTabIndexIO,
    updatedTabIndexIO,
    setUpdatedTabIndexIO,
    setMultipleIO,
    multipleIO


}) => {
    event.preventDefault();

    setAddedText(deviceType === "Text" ? text || "" : "");
    setBgColor(deviceType === "Display" ? bgColor || "#542A2A" : "");
    setTextBgColor(deviceType !== "Display" ? bgColor || "#ffffff" : "");
    setTextColor(deviceType === "Display" ? textColor || '#D90211' : "");
    setWidgetTextColor(deviceType !== "Display" ? textColor || "#000000" : "");
    setFontSize(deviceType === "Display" ? fontSize || 30 : "");
    setTextFontSize(deviceType !== "Display" ? fontSize || 30 : "");
    setTextAlignVertically(alignVertically || '');
    setTextAlignHorizontally(alignHorizontally || '');

    setDeviceMenuPosition({ x: event.clientX, y: event.clientY });
    setClickedDeviceIndex(index);
    setIsDeviceMenu(true);
    if (id) setSelectedDeviceId(id);
    setSelectedDevice(device);
    setCurrentDevice(deviceType);

    const deviceMappings = {
        Display: {
            tempTabIndex: tempTabIndexDisplay,
            updatedTabIndex: updatedTabIndexDisplay,
            setUpdatedTabIndex: setUpdatedTabIndexDisplay,
            multipleDevices: updatedMultipleDisplay,
            setMultipleDevices: setUpdatedMultipleDisplay
        },
        DigitalIO: {
            tempTabIndex: tempTabIndexIO,
            updatedTabIndex: updatedTabIndexIO,
            setUpdatedTabIndex: setUpdatedTabIndexIO,
            multipleDevices: multipleIO,
            setMultipleDevices: setMultipleIO
        },

        Text: {
            tempTabIndex: tempTabIndexText,
            updatedTabIndex: updatedTabIndexText,
            setUpdatedTabIndex: setUpdatedTabIndexText,
            multipleDevices: updatedMultipleText,
            setMultipleDevices: setUpdatedMultipleText
        },

        Motor: {
            tempTabIndex: tempTabIndexMotor,
            updatedTabIndex: updatedTabIndexMotor,
            setUpdatedTabIndex: setUpdatedTabIndexMotor,
            multipleDevices: updatedMultipleMotor,
            setMultipleDevices: setUpdatedMultipleMotor
        },

        LineChart: {
            tempTabIndex: tempTabIndexLineChart,
            updatedTabIndex: updatedTabIndexLineChart,
            setUpdatedTabIndex: setUpdatedTabIndexLineChart,
            multipleDevices: updatedMultipleLineChart,
            setMultipleDevices: setUpdatedMultipleLineChart
        },

        PieChart: {
            tempTabIndex: tempTabIndexPieChart,
            updatedTabIndex: updatedTabIndexPieChart,
            setUpdatedTabIndex: setUpdatedTabIndexPieChart,
            multipleDevices: updatedMultiplePieChart,
            setMultipleDevices: setUpdatedMultiplePieChart
        },

        BarChart: {
            tempTabIndex: tempTabIndexBarChart,
            updatedTabIndex: updatedTabIndexBarChart,
            setUpdatedTabIndex: setUpdatedTabIndexBarChart,
            multipleDevices: updatedMultipleBarChart,
            setMultipleDevices: setUpdatedMultipleBarChart
        },

        Histogram: {
            tempTabIndex: tempTabIndexHistogram,
            updatedTabIndex: updatedTabIndexHistogram,
            setUpdatedTabIndex: setUpdatedTabIndexHistogram,
            multipleDevices: updatedMultipleHistogram,
            setMultipleDevices: setUpdatedMultipleHistogram
        },

        Gauge: {
            tempTabIndex: tempTabIndexGauge,
            updatedTabIndex: updatedTabIndexGauge,
            setUpdatedTabIndex: setUpdatedTabIndexGauge,
            multipleDevices: updatedMultipleGauge,
            setMultipleDevices: setUpdatedMultipleGauge
        },

        ProgressBar: {
            tempTabIndex: tempTabIndexProgress,
            updatedTabIndex: updatedTabIndexProgress,
            setUpdatedTabIndex: setUpdatedTabIndexProgress,
            multipleDevices: updatedMultipleProgress,
            setMultipleDevices: setUpdatedMultipleProgress
        },

        Grid: {
            tempTabIndex: tempTabIndexGrid,
            updatedTabIndex: updatedTabIndexGrid,
            setUpdatedTabIndex: setUpdatedTabIndexGrid,
            multipleDevices: updatedMultipleGrid,
            setMultipleDevices: setUpdatedMultipleGrid
        },

        Table: {
            tempTabIndex: tempTabIndexTable,
            updatedTabIndex: updatedTabIndexTable,
            setUpdatedTabIndex: setUpdatedTabIndexTable,
            multipleDevices: updatedMultipleTable,
            setMultipleDevices: setUpdatedMultipleTable
        },

        CircularProgress: {
            tempTabIndex: tempTabIndexCircularProgress,
            updatedTabIndex: updatedTabIndexCircularProgress,
            setUpdatedTabIndex: setUpdatedTabIndexCircularProgress,
            multipleDevices: updatedMultipleCircularProgress,
            setMultipleDevices: setUpdatedMultipleCircularProgress,
        },

        Doughnut: {
            tempTabIndex: tempTabIndexDoughnut,
            updatedTabIndex: updatedTabIndexDoughnut,
            setUpdatedTabIndex: setUpdatedTabIndexDoughnut,
            multipleDevices: updatedMultipleDoughnut,
            setMultipleDevices: setUpdatedMultipleDoughnut,
        },

        Square: {
            tempTabIndex: tempTabIndexSquare,
            updatedTabIndex: updatedTabIndexSquare,
            setUpdatedTabIndex: setUpdatedTabIndexSquare,
            multipleDevices: updatedMultipleSquare,
            setMultipleDevices: setUpdatedMultipleSquare,
        },

        Circle: {
            tempTabIndex: tempTabIndexCircle,
            updatedTabIndex: updatedTabIndexCircle,
            setUpdatedTabIndex: setUpdatedTabIndexCircle,
            multipleDevices: updatedMultipleCircle,
            setMultipleDevices: setUpdatedMultipleCircle,
        },

        Radio: {
            tempTabIndex: tempTabIndexRadio,
            updatedTabIndex: updatedTabIndexRadio,
            setUpdatedTabIndex: setUpdatedTabIndexRadio,
            multipleDevices: updatedMultipleRadio,
            setMultipleDevices: setUpdatedMultipleRadio,
        },

        Slider: {
            tempTabIndex: tempTabIndexSlider,
            updatedTabIndex: updatedTabIndexSlider,
            setUpdatedTabIndex: setUpdatedTabIndexSlider,
            multipleDevices: updatedMultipleSlider,
            setMultipleDevices: setUpdatedMultipleSlider,
        },

        Lamp: {
            tempTabIndex: tempTabIndexLamp,
            updatedTabIndex: updatedTabIndexLamp,
            setUpdatedTabIndex: setUpdatedTabIndexLamp,
            multipleDevices: updatedMultipleLamp,
            setMultipleDevices: setUpdatedMultipleLamp,
        },
        Push: {
            tempTabIndex: tempTabIndexPush,
            updatedTabIndex: updatedTabIndexPush,
            setUpdatedTabIndex: setUpdatedTabIndexPush,
            multipleDevices: updatedMultiplePush,
            setMultipleDevices: setUpdatedMultiplePush,
        },
        Link: {
            tempTabIndex: tempTabIndexLink,
            updatedTabIndex: updatedTabIndexLink,
            setUpdatedTabIndex: setUpdatedTabIndexLink,
            multipleDevices: updatedMultipleLink,
            setMultipleDevices: setUpdatedMultipleLink,
        },
        Clock: {
            tempTabIndex: tempTabIndexClock,
            updatedTabIndex: updatedTabIndexClock,
            setUpdatedTabIndex: setUpdatedTabIndexClock,
            multipleDevices: updatedMultipleClock,
            setMultipleDevices: setUpdatedMultipleClock,
        }

    };


    updateDeviceSize(index, deviceType, id, tempImages, deviceMappings[deviceType]?.tempTabIndex, activeTabIndex, setTempImages, setUpdatedImages, deviceMappings[deviceType]?.updatedTabIndex, deviceMappings[deviceType]?.setUpdatedTabIndex);
    updateMultipleDevices(index, deviceMappings[deviceType]?.multipleDevices, deviceMappings[deviceType]?.setMultipleDevices);
};

const updateDeviceSize = (index, deviceType, id, tempImages, tempTabIndex, activeTabIndex, setTempImages, setUpdatedImages, updatedTabIndex, setUpdatedTabIndex) => {
    if (deviceType === "Display" || deviceType === "DigitalIO" || deviceType === "Text" || deviceType === "LineChart" || deviceType === "PieChart" || deviceType === "BarChart" || deviceType === "Histogram" || deviceType === "Gauge" || deviceType === "ProgressBar" || deviceType === "Grid" || deviceType === "Table" || deviceType === "Motor" || deviceType === "CircularProgress" || deviceType === "Doughnut" || deviceType === "Square" || deviceType === "Circle" || deviceType === "Radio" || deviceType === "Slider" || deviceType === "Lamp" || deviceType === "Push" || deviceType === "Link" || deviceType === "Clock") {

        if (!tempTabIndex[activeTabIndex]) return;

        const selectedElement = document.getElementById(`${deviceType.toLowerCase()}-${index}`);
        if (!selectedElement || !id) return;

        const { width, height } = selectedElement.style;

        const deviceIndex = tempImages.findIndex(device => device.id === id);
        if (deviceIndex === -1) return;

        tempImages[deviceIndex] = { ...tempImages[deviceIndex], width, height };
        setTempImages([...tempImages]);
        setUpdatedImages([...tempImages]);

        const tabIndexDevices = updatedTabIndex[activeTabIndex] || [];
        const tabIndexIndex = tabIndexDevices.findIndex(device => device.id === id);
        if (tabIndexIndex === -1) return;

        tabIndexDevices[tabIndexIndex] = { ...tabIndexDevices[tabIndexIndex], width, height };
        setUpdatedTabIndex({ [activeTabIndex]: tabIndexDevices });
    }

};

const updateMultipleDevices = (index, multipleDevices, setMultipleDevices) => {
    if (multipleDevices) {
        if (multipleDevices?.length <= 1) return;
        const selectedElement = document.getElementById(`new${multipleDevices[index].type.toLowerCase()}-${index}`);
        if (!selectedElement) return;

        const { width, height } = selectedElement.style;
        multipleDevices[index] = { ...multipleDevices[index], width, height };


        setMultipleDevices([...multipleDevices]);
    }
};



